"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var ResetPasswordMixin = /** @class */ (function () {
    function ResetPasswordMixin() {
    }
    ResetPasswordMixin.prototype.resetPasswordEmail = function (clientId, emailType, callback) {
        var _this = this;
        var mode;
        switch (emailType) {
            case models_1.ResetPasswordEmailType.reset:
                mode = 'emailReset';
                break;
            case models_1.ResetPasswordEmailType.welcome:
                mode = 'emailWelcome';
                break;
        }
        var body = { mode: mode };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/clients/" + clientId + "/password", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ResetPasswordMixin.prototype.resetPasswordLink = function (clientId, callback) {
        var _this = this;
        var body = { mode: 'link' };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.ResetPasswordLink.parse));
        };
        this.http.put("/clients/" + clientId + "/password", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ResetPasswordMixin.prototype.resetPasswordDino = function (clientId, callback) {
        var _this = this;
        var body = { mode: 'dino' };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.DinoPass.parse));
        };
        this.http.put("/clients/" + clientId + "/password", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ResetPasswordMixin.prototype.resetPasswordCustom = function (clientId, password, callback) {
        var _this = this;
        var body = { mode: 'custom', password: password };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/clients/" + clientId + "/password", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    return ResetPasswordMixin;
}());
exports.default = ResetPasswordMixin;
//# sourceMappingURL=ResetPasswordMixin.js.map